module.exports = __webpack_public_path__ + "img/woman-in-white-blazer-holding-tablet-computer-789822EDIT.b3128925.jpg";